import { Box, Grid } from '@material-ui/core';
import { useFormik } from 'formik';
import LocaleKeys from '../../../../locales/keys';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import TitleField from '../../../../common/forms/fields/components/titleField';
import FirstNameField from '../../../../common/forms/fields/components/firstNameField';
import LastNameField from '../../../../common/forms/fields/components/lastNameField';
import ButtonAction from '../../buttonAction';
import * as Yup from 'yup';
import {
  firstName,
  lastName,
} from '../../../../common/forms/validationSchemas';

const useStyles = makeStyles((theme) => ({
  'field__input--error': {
    borderColor: theme.palette.error.main,
    borderWidth: '2px',
  },
  nameContainer: {
    marginBottom: '17px',
  },
  titleField: {
    [theme.breakpoints.up('lg')]: {
      paddingRight: '15px',
    },
  },
  firstName: {
    [theme.breakpoints.up('lg')]: {
      padding: '0 15px',
    },
  },
  lastName: {
    [theme.breakpoints.up('lg')]: {
      paddingLeft: '15px',
    },
  },
  nameField: {
    paddingLeft: '0',
    [theme.breakpoints.between('xs', 'md')]: {
      width: '100%',
    },
  },
}));

const NameForm = ({
  handleCancel,
  handleSave,
  codeTableData,
  language,
  formData,
  formName,
  autoFocusRef,
}) => {
  const NameFieldSchema = Yup.object().shape({
    FirstName: firstName('firstName', language, codeTableData),
    LastName: lastName('lastName', language, codeTableData),
  });
  const classes = useStyles();
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: { ...formData },
    enableReinitialize: true,
    validationSchema: NameFieldSchema,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: (values) => {
      handleSave({ name: formName, formik, values });
    },
  });

  return (
    <Box className={classes.nameContainer}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container>
          <Grid
            className={`field field--title ${classes.titleField}`}
            item
            xs={12}
            lg={4}
          >
            <TitleField
              name="Title"
              form={formik}
              key={1}
              externalData={codeTableData}
              language={language}
            />
          </Grid>
          <Grid
            className={`field field--firstName ${classes.firstName}`}
            item
            xs={12}
            lg={4}
          >
            <FirstNameField
              name="FirstName"
              form={formik}
              key={2}
              externalData={codeTableData}
              language={language}
              autoFocusRef={autoFocusRef}
            />
          </Grid>
          <Grid
            className={`field field--lastName ${classes.lastName}`}
            item
            xs={12}
            lg={4}
          >
            <LastNameField
              name="LastName"
              form={formik}
              key={3}
              externalData={codeTableData}
              language={language}
            />
          </Grid>
        </Grid>
        <ButtonAction
          cancelHandler={handleCancel}
          formik={formik}
          saveLabel={t(LocaleKeys.accountInfo.save)}
          cancelLabel={t(LocaleKeys.accountInfo.cancel)}
          classes={classes}
          name={formName}
        />
      </form>
    </Box>
  );
};

export default NameForm;
